<div class="flex flex-row full-grow-no-shrink-no-basis">
  <particle-dynamic-country-selector [configKey]="configKey"
                                     [selectedCountryCodes]="selectedCountryCodes"
                                     (selectionChanged)="onSelectionChanged($event)"
                                     (isCheckboxDisabled)="false"
                                     [isItrceCountries]="false"
  ></particle-dynamic-country-selector>
</div>
